export const URLS = {
  auth: {
    LOGIN_URL: "/api/v1/auth/login",
    REGISTER_URL: "/api/v1/organizations",
    VALIDITY_URL: "/api/v1/auth/token/validity",
    TOKEN: "/api/v1/auth/token/refresh",
  },
  documents: {
    WORKPERMITS: "/api/v1/workpermits",
  },
  metadata: {
    WORK_TYPES: "/api/v1/metadata/work-types",
    HAZARDS: "/api/v1/metadata/hazards",
    PRECAUTIONS: "/api/v1/metadata/precautions",
    RECOVERY: "/api/v1/metadata/recovery-elements",
    RISK_RANKING: "/api/v1/metadata/risk-rankings",
  },
  admin: {
    WORK_TYPES: "/api/v1/org-admin/work-types",
    HAZARDS: "/api/v1/org-admin/hazards",
    PRECAUTIONS: "/api/v1/org-admin/precautions",
    RECOVERY: "/api/v1/org-admin/recovery-elements",
    RISK_RANKING: "/api/v1/org-admin/risk-rankings",
    SITES: "/api/v1/org-admin/sites",
    DEPARTMENTS: "/api/v1/org-admin/departments",
    USER_GROUP: "/api/v1/org-admin/user-groups",
  },
  users: {
    USER_ALL: "/api/v1/users",
    USER_DETAILS: "/api/v1/users/",
    USER_DELETE: "/api/v1/org-admin/users/",
  },
  organization: {
    SITES: "/api/v1/metadata/sites",
    DEPARTMENTS: "/api/v1/metadata/departments",
    USER_GROUPS: "/api/v1/metadata/user-groups",
  },
};
